<script setup lang="ts">
import { onMounted } from 'vue';
import CenterChildrenWrapper from '@components/layout-wrapper/center-children-wrapper.vue';
import Button from '@components/buttons/button.vue';
import Text from '@components/text.vue';
import Separator from '@components/separator.vue';

const props = withDefaults(
    defineProps<{
        message: string,
        onConfirm: (() => void)|null,
    }>(), {
        onConfirm: null,
    },
);
const emit = defineEmits<{
    confirm: [],
}>();

function onClick() {
    if (props.onConfirm !== null) {
        props.onConfirm();
    }
    emit('confirm');
}

onMounted(() => {
    if (!(document.activeElement instanceof HTMLElement)) {
        return;
    }
    document.activeElement.blur();
});
</script>

<template>
    <div>
        <Text
            :class="$style.error"
            alignment="center"
            size="1"
            line-spacing="1"
            v-html="message.replace(/\n/g, '<br/>')"
        />
        <Separator :border="false" gap="1"/>
        <CenterChildrenWrapper>
            <Button :class="$style.button" @click="onClick">OK</Button>
        </CenterChildrenWrapper>
    </div>
</template>

<style lang="scss" module>
    .error {
        max-width: 60em;
    }
    .button {
        min-width: 7em;
    }
</style>
